import { render } from "./ProjectShowTeams.vue?vue&type=template&id=f8092682"
import script from "./ProjectShowTeams.vue?vue&type=script&lang=js"
export * from "./ProjectShowTeams.vue?vue&type=script&lang=js"
script.render = render

export default script